import { faRetweet } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import useAsyncCallback from "../../../hooks/useAsyncCallback";
import UnForm from "../../Form";
import {
    AtualizarStatusCobrancaController,
    BuscaStatusCobrancaController,
} from "../../../Controllers/Atendimentos/Atendimento";
import { GetVendaController } from "../../../Controllers/Geral/InformacoesVenda/InformacoesVendaControllers";
import { IListaStatusCobranca } from "../../../Interfaces/Cobranca/GestaoAtendimento/GestaoAtendimentoInterface";
import SpinnerComponent from "../../Loding/Spinner";

interface IAlterarStatusCobrancaProps {
    setShow: (show: boolean) => void;
    ID_CHAVE_ERP_VENDA: string | undefined;
}

export default function AlterarStatusCobranca(
    props: IAlterarStatusCobrancaProps
) {
    const [lstStatusCobranca, setLstStatusCobranca] = useState<
        Array<IListaStatusCobranca>
    >([]);
    const [loading, setLoading] = useState<boolean>(false);

    const { execute: listarStatusCobranca } = useAsyncCallback(
        () => BuscaStatusCobrancaController(),
        []
    );
    const { execute: getVenda } = useAsyncCallback(
        () => GetVendaController(props.ID_CHAVE_ERP_VENDA ?? ""),
        [props.ID_CHAVE_ERP_VENDA]
    );
    const {
        execute: atualizarStatusCobranca,
        loading: atualizarStatusCobrancaLoading,
    } = useAsyncCallback(
        (ID_CHAVE_ERP_VENDA, responseBody) =>
            AtualizarStatusCobrancaController(ID_CHAVE_ERP_VENDA, responseBody),
        []
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const listarStatusCobrancaDaVenda = () => {
        const lstStatusCobrancaTemp: {
            encontrado: boolean;
            Codigo: number;
            Descricao: string;
        }[] = [];
        setLoading(true);
        listarStatusCobranca().then((res) => {
            getVenda()
                .then((venda) => {
                    res.forEach((statusCobranca) => {
                        const encontrado = venda.LstCobrancas.some(
                            (cobrancasValue) =>
                                cobrancasValue === Number(statusCobranca.Codigo)
                        );
                        lstStatusCobrancaTemp.push({
                            ...statusCobranca,
                            encontrado,
                        });
                    });
                })
                .finally(() => {
                    setLstStatusCobranca(lstStatusCobrancaTemp);
                    setLoading(false);
                });
        });
    };

    useEffect(() => {
        listarStatusCobrancaDaVenda();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCheckboxChange = (codigo: number) => {
        setLstStatusCobranca((prevState) => {
            return prevState.map((item) => {
                if (item.Codigo === codigo) {
                    return { ...item, encontrado: !item.encontrado };
                }
                return item;
            });
        });
    };
    function handleAlterarEtapa(formData: any) {
        let lstStatusFormatado = [];

        for (let key in formData) {
            if (formData[key] === true) {
                lstStatusFormatado.push({ codigo: Number(key) });
            }
        }
        atualizarStatusCobranca(
            props.ID_CHAVE_ERP_VENDA,
            lstStatusFormatado
        ).then(() => {
            props.setShow(false);
        });
    }

    return (
        <>
            {loading ? (
                <SpinnerComponent />
            ) : (
                <UnForm handleSubmit={handleAlterarEtapa}>
                    <div
                        style={{
                            gap: "18px",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >
                        {lstStatusCobranca.map((res) => {
                            return (
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                    }}
                                >
                                    <UnForm.Input
                                        type="checkbox"
                                        style={{
                                            width: "40px",
                                            marginRight: "8px",
                                        }}
                                        name={String(res.Codigo)}
                                        onChange={() =>
                                            handleCheckboxChange(res.Codigo)
                                        }
                                        checked={res.encontrado}
                                    />
                                    <span>{res.Descricao}</span>
                                </div>
                            );
                        })}
                    </div>
                    <UnForm.SubmitButton
                        loading={atualizarStatusCobrancaLoading}
                        wrapperClassName="d-flex col-12 justify-content-end mt-3 mr-0 p-0"
                        disabled={atualizarStatusCobrancaLoading}
                        className="col-12"
                        icon={faRetweet}
                        color="success"
                        loadingSize="sm"
                    >
                        Alterar Etapa
                    </UnForm.SubmitButton>
                </UnForm>
            )}
        </>
    );
}
